import React from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import ModalHeader from 'redesign/components/molecules/comment-modal-header'
import { DIALOG_SIZES } from '../../molecules/dialog/constants'
import DrawerModal from '../drawer-modal'
import type { TimelineActionDialogProps } from './types'

const TimelineActionDialog: React.FC<TimelineActionDialogProps> = ({
  isOpen,
  onClose,
  title = '',
  content,
  footer,
  dialogSize = DIALOG_SIZES.small,
  badge,
}) => {
  const { breakpoints } = useTheme()
  const isSmallScreen = useMediaQuery(breakpoints.down('sm'))

  return (
    <DrawerModal
      showPuller
      onClose={onClose}
      isOpen={isOpen}
      header={<ModalHeader headerLabel={badge ?? title} onClick={() => {}} onClose={onClose} />}
      dialogSize={dialogSize}
      isSmallScreen={isSmallScreen}
      footer={footer}
      noPadding
    >
      {content}
    </DrawerModal>
  )
}

export default TimelineActionDialog
